import type { FormProps } from "antd";
import { Form, Input, Row } from "antd";
import { useNavigate } from "react-router-dom";
import * as S from "./LoginForm.styles";
import logo from "../../assets/tinsa_logo.png";
import { AuthData } from "../../api/auth.api";
import { useDispatch } from "react-redux";
import { doLogin } from "../../store/slices/authSlice";
import { AppDispatch, RootState } from "../../store/store";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

function LoginForm() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.auth);
  const isLoading: boolean =
    loading !== "idle" && loading !== "succeeded" && loading !== "failed";
  type FieldType = {
    email?: string;
    password?: string;
  };
  const handleLogin = async () => {
    try {
      const values: AuthData = await form.validateFields();
      const loginData: AuthData = {
        email: values.email,
        password: values.password,
      };

      // Dispatch the login action and get the result
      const result: any = await dispatch(doLogin(loginData)).unwrap();

      console.log(result);

      if (result.user.role === "visiteur") {
        navigate("/lancerVisite");
        
      }
      else if (result.user.role === "admin" || result.user.role === "controleur") {
        navigate("/");
      }

      // Display the toast message with updated user data from result
      toast.success(
        `Connecté(e) : ${result.user.nom} ${result.user.prenom} (${result.user.role})`
      );

      
    } catch (error) {
      console.error("Something went wrong:", error);
      toast.error("Une erreur est survenue.");
    }
  };

  const onFinishFailed: FormProps<FieldType>["onFinishFailed"] = (
    errorInfo
  ) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <S.LoginFormWrapper>
      <S.LoginCard
        title={
          <Row justify={"space-between"} align={"middle"}>
            <p
              style={{
                fontFamily: "Quicksand,BenchNine ,Roboto,sans-serif",
                fontSize: "30px",
                fontWeight: "500",
              }}
            >
              TinsaCore
            </p>
            <S.LogoImage src={logo} />
          </Row>
        }
      >
        <Form
          layout="vertical"
          name="basic"
          onFinish={handleLogin}
          onFinishFailed={onFinishFailed}
          style={{ width: "100%" }}
          form={form}
        >
          <Form.Item<FieldType>
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Veuillez saisir votre email!" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item<FieldType>
            label="Mot de passe"
            name="password"
            rules={[
              {
                required: true,
                message: "Veuillez saisir votre mot de passe!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Row justify={"end"}>
            <Form.Item>
              <S.LoginButton
                loading={isLoading}
                type="primary"
                htmlType="submit"
              >
                Se connecter
              </S.LoginButton>
            </Form.Item>
          </Row>
        </Form>
      </S.LoginCard>
    </S.LoginFormWrapper>
  );
}

export default LoginForm;
